import { render, staticRenderFns } from "./CompetitionPresentItem.vue?vue&type=template&id=a45e6bc0&scoped=true"
import script from "./CompetitionPresentItem.vue?vue&type=script&lang=ts"
export * from "./CompetitionPresentItem.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionPresentItem.vue?vue&type=style&index=0&id=a45e6bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e6bc0",
  null
  
)

export default component.exports